import { StringHelpers, SystemText } from 'e4shared';
import { e4Format, isPast, isToday } from 'helpers/dates';

export const Bullet = ({
    style,
    icon,
    type,
    subType,
    value,
    size,
    isDate,
    isDueDate,
    isOpenDueDate,
    isDuration,
    isStatus,
}) => {
    if (isDueDate) {
        value = SystemText('Controls/Bullet/Due', e4Format(value));
        icon = 'calendar';
        style = 'steel';
    }

    if (isOpenDueDate) {
        if (isToday(value)) {
            value = SystemText('Controls/Bullet/Today');
            icon = 'triangle-exclamation';
            style = 'due';
        } else if (isPast(value)) {
            value = SystemText('Controls/Bullet/Overdue');
            icon = 'circle-exclamation';
            style = 'overdue';
        } else {
            value = SystemText('Controls/Bullet/Due', e4Format(value));
            icon = 'calendar';
            style = 'steel';
        }
    }

    if (isDate) {
        value = e4Format(value);
        icon = 'calendar';
        style = 'steel';
    }

    if (isDuration) {
        icon = 'clock';
        style = 'desert';
        value = StringHelpers.displayMinutes(Math.max(1, value));
    }

    if (isStatus) {
        switch (value?.toLowerCase()) {
            case 'outstanding':
                icon = 'calendar';
                style = 'steel';
                value = SystemText('Controls/Bullet/Outstanding');
                break;
            case 'in_progress':
                icon = 'spinner';
                style = 'steel';
                value = SystemText('Controls/Bullet/InProgress');
                break;
            case 'due_today':
                icon = 'warning';
                style = 'today';
                value = SystemText('Controls/Bullet/Today');
                break;
            case 'late':
                icon = 'circle-exclamation';
                style = 'overdue';
                value = SystemText('Controls/Bullet/Late');
                break;
            case 'completed':
                icon = 'badge-check';
                style = 'success';
                value = SystemText('Controls/Bullet/Completed');
                break;
            case 'on_time':
                icon = 'badge-check';
                style = 'success';
                value = SystemText('Controls/Bullet/OnTime');
                break;
            case 'overdue':
                icon = 'circle-exclamation';
                style = 'overdue';
                value = SystemText('Controls/Bullet/Overdue');
                break;
            case 'awaiting_approval':
                icon = 'spinner';
                style = 'amber';
                value = SystemText('Controls/Bullet/AwaitingApproval');
                break;
            default:
                break;
        }
    }

    switch (type) {
        case 'behavior':
            icon = 'user-gear';
            value = SystemText('Controls/Bullet/Type/Behavior');
            style = 'behaviour round';
            break;
        case 'course':
            icon = 'arrow-up-right-from-square';
            value = SystemText('Controls/Bullet/Type/Course');
            style = 'course round';
            break;
        case 'objective':
            value = SystemText('Controls/Bullet/Type/Objective');
            switch (subType?.toLowerCase()) {
                case 'video':
                case 'pitchback':
                    icon = 'video';
                    style = 'round objective-video';
                    break;
                case 'metric':
                    icon = 'ruler';
                    style = 'round objective-metric';
                    break;
                case 'lms':
                case 'learn':
                    icon = 'graduation-cap';
                    style = 'round objective-lms';
                    break;
                case 'ai':
                    icon = 'sparkles';
                    style = 'round objective-ai';
                    value = SystemText('Controls/Bullet/Type/AIObjective');
                    break;
                default:
                    icon = 'square-check';
                    style = 'round objective';
                    break;
            }

            break;
        case 'pathway':
            icon = 'route';
            value = SystemText('Controls/Bullet/Type/Pathway');
            style = 'pathway round';
            break;
        case 'metric':
            icon = 'route';
            value = SystemText('Controls/Bullet/Type/Matric');
            style = 'metric round';
            break;
        case 'review':
            icon = 'gauge';
            value = SystemText('Controls/Bullet/Type/Review');
            style = 'review round';
            break;
        default:
            break;
    }

    return (
        <div className={`prism-bullet no-wrap ${style}`} style={size === 'lg' ? { fontSize: '14px' } : null}>
            {icon && <i className={`fa fa-${icon} mr5`} />}
            {value}
        </div>
    );
};

export default Bullet;
